export default "__VITE_ASSET__BvRhNUjt__"